const locations = {
  toast: {
    error: {
      badResponse: '[Standort] Fehlerhafte Serverantwort',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Standort] wurde erfolgreich erstellt',
      },
      edit: {},
      delete: {
        default: '[Standort] wurde erfolgreich gelöscht',
      },
    },
  },
  headerButtons: {
    create: {
      createBtn: 'Erstellen',
    },
    import: 'Importieren',
  },

  deleteModal: {
    header: 'Standorte löschen',
    body: 'Sie sind dabei, {{num}} Standorte zu löschen.',
  },

  printoutsModal: {
    title: 'PDF-Export für Ausdrucke',
    description: 'Bitte wählen Sie einen Datumsbereich (maximal 31 Tage)',
    maxRangeError: 'Bitte wählen Sie einen Bereich von 31 Tagen oder weniger',
    export: 'Exportieren',
  },

  table: {
    filters: {
      type: 'Typ',
    },
    actions: {
      delete: 'Löschen',
      export: 'Exportieren',
      printouts: 'Ausdrucke',
    },
    moreActions: {
      showOnMap: 'Auf Karte anzeigen',
    },
    headers: {
      name: 'Name',
      type: 'Typ',
      address: 'Adresse',
      lat: 'Breitengrad',
      lon: 'Längengrad',
      locationTypes: {
        location: 'Standort',
        inAndOut: 'Ein-/Ausstieg',
        airport: 'Flughafen',
        facility: 'Einrichtung',
      },
      wait: 'Warten',
    },
    toolTip: {
      noPermission: 'Aktion nicht zulässig: Berechtigung erforderlich',
    },
  },

  form: {
    header: {
      createLocation: {
        title: 'Erstellen',
      },
      updateLocation: {
        title: 'Aktualisieren',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },

    addressInformation: {
      title: 'Adressinformationen',
      name: 'Name',
      type: 'Typ',
      wait: 'Warten',
      address: 'Adresse',
      locationTypes: {
        location: 'Standort',
        inAndOut: 'Ein-/Ausstieg',
        airport: 'Flughafen',
        facility: 'Einrichtung',
      },
    },

    radius: {
      title: 'Adressabgleich-Radius',
      toolTipInformation:
        'Der Radius in Metern oder Fuß (m/ft je nach metrisch/imperial), innerhalb dessen Reservierungen als Standort und/oder als „Warten & Rückfahrt“-Bereich erkannt werden.',
    },

    waitAndReturn: {
      title: 'Warten & Rückfahrt',
      time: 'Wartezeit',
      timeDescription:
        'Die Dauer in Minuten, die ein Fahrer zwischen der Hinfahrt und der Rückfahrt einer „Warten & Rückfahrt“-Fahrt wartet.',
    },

    advancedSettings: {
      consistentPassengerRouting: {
        title: 'Einheitliche Fahrgastführung',
        toolTipInformation:
          'Stellt sicher, dass dieselbe Fahrgastgruppe stets dieselbe Route zur und von der Einrichtung nutzt – das erhöht die Effizienz und reduziert Verwirrung.',
      },
      snapAddressWithinRadius: {
        title: 'Adresse innerhalb des Radius zuordnen',
        toolTipInformation:
          'Wenn sich eine Abhol-/Abgabeadresse innerhalb des Standortradius befindet, wird sie dem Namen und den Koordinaten des Standorts zugeordnet',
      },
      sameDriverForGroup: {
        title: 'Gleicher Fahrer für die Gruppe',
        toolTipInformation:
          'Weist denselben Fahrer für die Beförderung der Fahrgastgruppe sowohl für Abholung als auch Absetzung zu und sorgt so für Vertrautheit und Konsistenz.',
      },
      overrideOptions: {
        bySystemSettings: 'By System Settings',
        enabled: 'Enabled',
        disabled: 'Disabled',
      },
      allowSharedRide: {
        title: 'Gemeinsame Fahrt mit anderen Adressen zulassen',
        toolTipInformation:
          'When enabled, this setting allows shared rides to be grouped with bookings from other locations that have consistent routes. If disabled, only rides from the same location will be considered for grouping.',
      },
      tripBoardingTime: {
        title: 'Einstiegszeit',
        toolTipInformation:
          'Die Zeit die benätigt wird um einen Fahrgast an seiner Haltestelle abzuholen (dieser Parameter wirkt sich auf die Gesamtdauer der Fahrt aus)',
      },
      waitForBoardingTime: {
        title: 'Auf Abholzeit warten',
        toolTipInformation: 'Beim Erreichen einer Haltestelle wartet der Fahrer bei Bedarf bis zur exakten Abholzeit.',
      },
      tripDropOffTime: {
        title: 'Ausstiegszeit',
        toolTipInformation:
          'Die Zeit die benätigt wird um einen Fahrgast an seiner Haltestelle abzusetzen (dieser Parameter wirkt sich auf die Gesamtdauer der Fahrt aus)',
      },
      pickupTimeBuffer: {
        title: 'Pickup Time Buffer',
        toolTipInformation: 'Adjusts the reservation pickup time by a configurable number of minutes when this location matches the booking.',
        directionTitle: 'Buffer Direction',
        directionToolTipInformation: 'Choose whether this pickup-time buffer applies when the reservation matches this location as the origin, destination, or either side.',
        directionOptions: {
          to: 'To',
          from: 'From',
          both: 'Both',
        },
      },
      rules: {
        header: 'Standort-/Profilregeln',
        rule: 'Regel',
        profiles: 'Profil',
        addNewRule: '+ Standort-/Profilregel hinzufägen',
      },
      maxDropOffEarly: {
        title: 'Maximal frühes Aussteigen',
        toolTipInformation:
          'Maximale Anzahl von Minuten die ein Fahrer im Verhältnis zur in der Reservierung festgelegten Ausstiegszeit früher kommen kann.',
      },
      maxDropOffDelay: {
        title: 'Maximale Ausstiegsverzägerung',
        toolTipInformation:
          'Maximale Anzahl von Minuten die ein Fahrer zu spät zur in der Reservierung festgelegten Abgabezeit kommen darf',
      },
      maxBoardingDelay: {
        title: 'Maximale Einsteigeverspätung',
        toolTipInformation:
          'Maximale Anzahl von Minuten, die ein Fahrer im Verhältnis zur in der Reservierung festgelegten Abholzeit zu spät ankommen darf.',
      },
      maxBoardingEarly: {
        title: 'Maximal frühes Einsteigen',
        toolTipInformation:
          'Maximale Anzahl von Minuten die ein Fahrer im Verhältnis zur in der Reservierung festgelegten Abholzeit früher kommen kann',
      },
      maxTripDuration: {
        title: 'Maximale Fahrtdauer',
        toolTipInformation: 'Maximale Dauer einer Fahrt in Minuten.',
      },
      maxSinglePassengerTime: {
        title: 'Maximale Fahrzeit pro Passagier',
        toolTipInformation: 'Maximale Fahrtdauer in Minuten pro Fahrgast.',
      },
    },

    advanced: {
      title: 'Erweitert',
      addTime: {
        addTimeBtn: 'Zeit hinzufügen',
        name: 'Name',
        minutes: 'Minuten',
        enterMinutes: 'Minuten eingeben',
        enterName: 'Namen eingeben',
      },
    },

    map: {
      title: 'Karte',
    },
    site: {
      title: 'Bereich',
    },

    info: {
      subLocations: {
        addSubLocationBtn: 'Terminal hinzufügen',
        header: 'Terminal',
        fields: {
          subLocation: 'Adresse',
          name: {
            label: 'Adresse',
            placeholder: 'Name',
          },
        },
      },
    },
  },

  update: {
    confirmButtonText: 'Aktualisieren',
    formTabs: {
      info: 'Info',
      advancedSettings: 'Erweiterte Einstellungen',
      history: 'Verlauf',
    },

    successToast: {
      message: 'Aktualisiert! Standort wurde erfolgreich aktualisiert.',
    },

    errorToast: {
      message: 'Fehler. Standort konnte nicht aktualisiert werden.',
    },
  },

  create: {
    formTabs: {
      info: 'Info',
      advancedSettings: 'Erweiterte Einstellungen',
    },
    successToast: {
      message: 'Erstellt! Standort wurde erfolgreich erstellt.',
    },

    errorToast: {
      message: 'Fehler. Standort konnte nicht erstellt werden.',
    },
  },

  delete: {
    successToast: {
      message: 'Gelöscht! Standort wurde erfolgreich gelöscht.',
    },

    errorToast: {
      message: 'Fehler. Standort konnte nicht gelöscht werden.',
    },
  },

  createModal: {
    title: 'Warten & Rückfahrt',
    body: 'Sie sind dabei, diesen Standort als „Warten & Rückfahrt“-Standort festzulegen. Dadurch wird die Einstellung „Warten & Rückfahrt“ automatisch auf alle zukünftigen Buchungen an diesem Standort angewendet. Möchten Sie wirklich fortfahren?',
  },
  enableLocationTypeModal: {
    title: 'Warten & Rückfahrt',
    body: 'Sie sind dabei, die Einstellung „Warten & Rückfahrt“ zu aktivieren. Dies gilt für alle aktuellen und zukünftigen Buchungen, die als „Warten & Rückfahrt“ gelten. Möchten Sie wirklich fortfahren?',
  },
  disableLocationTypeModal: {
    title: 'Warten & Rückfahrt',
    body: 'Sie sind dabei, die Einstellung „Warten & Rückfahrt“ zu deaktivieren. Dadurch wird sie aus allen aktuellen und zukünftigen Buchungen entfernt, die als „Warten & Rückfahrt“ gekennzeichnet sind. Möchten Sie wirklich fortfahren?',
  },
  deleteLocationTypeModal: {
    title: 'Sie sind dabei {{count}} Standorte zu löschen.',
    titleAll: 'Sie sind dabei alle Standorte zu löschen.',
    body: '"Diese Standorte enthalten einen ä""Warte- und Zurückkehren""-Standort. Dadurch wird die Einstellung ""Warten und Zurückkehren"" automatisch auf alle zukänftigen Buchungen an diesem Standort angewendet. Mächten Sie wirklich fortfahren?"',
  },
  updateLocationOfTypeLocationModal: {
    title: 'Warten und zurückkehren',
    body: '"Sie sind dabei diesen Standort in einen ""Warte- und Zurückkehren""-Standort umzuwandeln. Dadurch wird die Einstellung ""Warten und Zurückkehren"" automatisch auf alle zukänftigen Buchungen an diesem Standort angewendet. Mächten Sie wirklich fortfahren?"',
  },
};

export default locations;
